import React from 'react'
import "./Loader.css"

const Loader = () => {
  return (
    <div class="loader">
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
</div>
  )
}

export default Loader
